export default __webpack_public_path__ + "static/pollo-75889ac0e08efb870ca437134add39d2.png";